import { Inner, Outer } from './styled';

export { Inner, Outer };
